import { Link } from 'react-router-dom';
import Icon from './Icon';
import { IMG, u } from '../images';

const CHIPS = ['Web Development', 'Mobile Apps', 'UI/UX Design', 'Branding', '2D/3D Animation', 'E-Commerce', 'Digital Marketing', 'Cloud & DevOps', 'AI & Automation'];

function PhotoCollage() {
  return (
    <div className="relative mx-auto aspect-[5/6] w-full max-w-[520px]">
      <div className="absolute inset-[10%] rounded-full bg-brand-lime/20 blur-3xl" />
      <div className="absolute inset-x-[14%] inset-y-0 overflow-hidden rounded-t-[999px] rounded-b-[2rem] border border-brand-lime/30 shadow-2xl">
        <img src={u(IMG.hero[0], 900)} alt="Origo team collaborating" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-brand/20 to-transparent" />
      </div>
      <div className="absolute -left-2 top-[30%] h-40 w-32 animate-floaty overflow-hidden rounded-2xl border-4 border-ink shadow-xl sm:left-0 sm:h-48 sm:w-40">
        <img src={u(IMG.hero[1], 400)} alt="" className="h-full w-full object-cover" />
      </div>
      <div className="absolute -right-2 bottom-[18%] h-32 w-40 animate-floaty overflow-hidden rounded-2xl border-4 border-ink shadow-xl [animation-delay:-3s] sm:right-0 sm:h-36 sm:w-48">
        <img src={u(IMG.hero[2], 400)} alt="" className="h-full w-full object-cover" />
      </div>
      <div className="absolute left-0 top-[8%] animate-floaty rounded-2xl border border-white/10 bg-ink/70 px-4 py-3 text-white backdrop-blur-md [animation-delay:-1.5s]">
        <p className="text-[11px] uppercase tracking-wider text-white/60">Delivered</p>
        <p className="font-display text-xl font-bold">120+ projects</p>
      </div>
      <div className="absolute bottom-[4%] left-[10%] flex animate-floaty items-center gap-3 rounded-2xl bg-brand-lime px-4 py-3 text-ink shadow-xl [animation-delay:-4s]">
        <Icon name="star" className="h-5 w-5 fill-current" />
        <span className="font-display text-lg font-bold">4.9 <span className="text-xs font-medium opacity-70">client rating</span></span>
      </div>
      <div className="absolute -right-6 top-[6%] hidden h-24 w-24 animate-spinslow rounded-full border-2 border-dashed border-brand-lime/40 sm:block" />
    </div>
  );
}

export default function Hero() {
  return (
    <section
      className="relative overflow-hidden pt-32 text-white sm:pt-36"
      style={{
        backgroundColor: '#04181a',
        backgroundImage: [
          'radial-gradient(ellipse 60% 55% at 85% 20%, rgba(53,181,161,.35) 0%, transparent 70%)',
          'radial-gradient(ellipse 55% 60% at 10% 85%, rgba(32,144,128,.28) 0%, transparent 70%)',
          'linear-gradient(135deg, #020c0d 0%, #07282b 38%, #0f5557 75%, #16807a 110%)',
        ].join(', '),
      }}
    >
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute -left-40 top-20 h-[480px] w-[480px] rounded-full bg-brand-mid/50 blur-[130px]" data-parallax="0.4" />
      <div className="pointer-events-none absolute -right-40 bottom-0 h-[420px] w-[420px] rounded-full bg-brand-lime/25 blur-[130px]" data-parallax="-0.3" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/30" />

      <div className="container-x relative grid items-center gap-14 pb-20 lg:grid-cols-[1.1fr_.9fr] lg:pb-28">
        <div>
          <span className="eyebrow eyebrow-dark" data-anim="down">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-lime" /> Software · Design · Animation · Marketing
          </span>
          <h1 className="mt-6 text-[1.9rem] font-bold leading-[1.22] sm:text-4xl xl:text-[3rem]" data-split data-delay="0.1">
            We build <span className="text-accent-light">digital products</span> that <span className="text-gradient">grow</span> your <span className="text-outline-light">business</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg" data-anim="up" data-delay="0.35">
            Origo Private Limited is a full-service technology partner — websites, mobile apps, UI/UX, branding, 2D/3D animation and digital marketing, delivered end to end by one dedicated team.
          </p>
          <div className="mt-9 flex flex-wrap gap-4" data-anim="up" data-delay="0.5">
            <Link to="/contact" className="btn-primary">Start your project <Icon name="arrow" className="h-4 w-4" /></Link>
            <Link to="/services" className="btn-ghost">Explore services</Link>
          </div>
          <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-3 text-sm text-white/65" data-anim="fade" data-delay="0.7">
            {['Free consultation', 'Fixed-price quotes', '100% code ownership'].map((t) => (
              <li key={t} className="flex items-center gap-2"><Icon name="check" className="h-4 w-4 text-brand-lime" strokeWidth={2.4} />{t}</li>
            ))}
          </ul>
        </div>

        <div data-anim="zoom" data-delay="0.3">
          <PhotoCollage />
        </div>
      </div>

      {/* services ticker */}
      <div className="relative border-y border-white/10 bg-brand-dark/60 py-4 backdrop-blur">
        <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
          {[...CHIPS, ...CHIPS].map((c, i) => (
            <span key={i} className="flex items-center gap-10 font-display text-sm font-medium uppercase tracking-[0.18em] text-white/60">
              {c}<span className="h-1.5 w-1.5 rounded-full bg-brand-lime" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
